/* eslint-disable max-len */
// The purpose of having separate Portal and PortalTwo files is so that PortalTwo can be used to display an error modal when there is already content (most likely a form) displayed as a modal that is mounted to the Portal component's root element.

// Node Modules
import { useEffect } from 'react'

import ReactDOM from 'react-dom'

// Use a ternary operator to make sure that the document object is defined
const portalRoot = typeof document !== 'undefined' ? document.getElementById('portal-two') : null

const PortalTwo = ({ children, className }) => {
  const el = typeof document !== 'undefined' ? document.createElement('div') : null
  useEffect(() => {
    portalRoot.appendChild(el)
    return () => {
      portalRoot.removeChild(el)
    }
  }, [el])

  // Check that this.el is not null before using ReactDOM.createPortal
  if (el) {
    return ReactDOM.createPortal(children, el)
  }

  return null
}
export default PortalTwo
